import React from 'react';

const NvidiaDGXSpark = () => (
  <article className="news-article-body">
    <p className="news-lead">
      In October 2025, NVIDIA began shipping the <strong>DGX Spark</strong> — the world's smallest
      AI supercomputer. Delivering 1 petaflop of FP4 compute in a compact desktop enclosure,
      it brings data-centre-grade AI capability to individual developers and research labs.
    </p>

    <h2>The Significance of "Desktop Supercomputer"</h2>
    <p>
      Historically, training or fine-tuning large models required either cloud GPU instances or
      on-premise rack hardware costing hundreds of thousands of dollars. The DGX Spark collapses
      that barrier to entry. A single unit can:
    </p>
    <ul>
      <li>Run inference on models up to <strong>200 billion parameters</strong></li>
      <li>Fine-tune models up to <strong>70 billion parameters</strong> locally</li>
      <li>Generate high-resolution images and perform data science workloads</li>
      <li>Host full AI agent stacks with local privacy</li>
    </ul>

    <h2>Key Specifications</h2>
    <div className="news-specs-grid">
      <div className="news-spec-item">
        <span className="news-spec-label">AI Performance</span>
        <span className="news-spec-value">1 PFLOP (FP4)</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Unified Memory</span>
        <span className="news-spec-value">128 GB CPU-GPU Coherent</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Architecture</span>
        <span className="news-spec-value">NVIDIA GB10 Grace Blackwell</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Networking</span>
        <span className="news-spec-value">ConnectX-7 200 Gb/s + NVLink-C2C</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Form Factor</span>
        <span className="news-spec-value">Compact desktop</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Partners</span>
        <span className="news-spec-value">Acer, ASUS, Dell, GIGABYTE, Lenovo, MSI</span>
      </div>
    </div>

    <h2>The Jensen Musk Moment</h2>
    <p>
      NVIDIA CEO Jensen Huang personally hand-delivered one of the first DGX Spark units to
      Elon Musk at SpaceX's Starbase in Texas — a deliberate callback to 2016, when Huang
      hand-delivered the very first DGX-1 to Musk at OpenAI. The symbolic gesture marked
      nearly a decade of AI infrastructure evolution.
    </p>

    <h2>Performance Growth Since Launch</h2>
    <p>
      By January 2026, NVIDIA reported a <strong>2.5× average performance improvement</strong>
      across software libraries and frameworks since the DGX Spark's initial shipping — with
      the largest gains in LLM prefill performance, the compute-intensive phase of inference
      handling new input tokens.
    </p>

    <h2>Implications for Enterprise AI</h2>
    <p>
      For enterprises with data sovereignty requirements, the DGX Spark offers a compelling
      on-premise option: frontier model inference without data leaving the building. Regulated
      industries (finance, healthcare, government) that cannot send data to cloud inference
      endpoints now have a viable local alternative at accessible price points.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        The DGX Spark marks the democratisation of frontier AI compute. As desktop AI
        supercomputers become common, the advantage shifts from <em>access to compute</em>
        to <em>quality of data and domain expertise</em> — exactly the assets enterprises
        already own.
      </p>
    </div>
  </article>
);

export default NvidiaDGXSpark;
